import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCtmsConfig,
  createCtmsConfig,
  updateCtmsConfig,
} from "adapters/ctms.service";

const extractError = (err) =>
  err?.response?.data?.message || err?.message || "Unknown error";

export const fetchCtmsConfig = createAsyncThunk(
  "ctms/fetchConfig",
  async (_arg, { rejectWithValue }) => {
    try {
      return await getCtmsConfig();
    } catch (err) {
      return rejectWithValue(extractError(err));
    }
  }
);

export const saveCtmsConfig = createAsyncThunk(
  "ctms/saveConfig",
  async ({ payload, isUpdate }, { rejectWithValue }) => {
    try {
      return isUpdate
        ? await updateCtmsConfig(payload)
        : await createCtmsConfig(payload);
    } catch (err) {
      return rejectWithValue(extractError(err));
    }
  }
);

const initialState = {
  config: null,
  loading: { config: false, save: false },
  error: { config: null, save: null },
};

const ctmsSlice = createSlice({
  name: "ctms",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCtmsConfig.pending, (state) => {
        state.loading.config = true;
        state.error.config = null;
      })
      .addCase(fetchCtmsConfig.fulfilled, (state, action) => {
        state.loading.config = false;
        state.config = action.payload;
      })
      .addCase(fetchCtmsConfig.rejected, (state, action) => {
        state.loading.config = false;
        state.error.config = action.payload || "Unknown error";
      })
      .addCase(saveCtmsConfig.pending, (state) => {
        state.loading.save = true;
        state.error.save = null;
      })
      .addCase(saveCtmsConfig.fulfilled, (state) => {
        state.loading.save = false;
      })
      .addCase(saveCtmsConfig.rejected, (state, action) => {
        state.loading.save = false;
        state.error.save = action.payload || "Unknown error";
      });
  },
});

export const selectCtmsConfig = (s) => s.ctms.config;
export const selectCtmsLoading = (s) => s.ctms.loading;
export const selectCtmsError = (s) => s.ctms.error;

export default ctmsSlice.reducer;
